import { debounce } from "lodash";
import moment from "moment";
import * as React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";
import { Form, actions } from "react-redux-form";
import { routerActions } from "react-router-redux";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import { RestrictedLayout } from "src/components/layouts";
import {
    CommitteeMeetingCreateBreadcrumbs,
    CommitteeMeetingDetailsBreadcrumbs,
} from "src/helpers/breadcrumbHelper";
import { CommitteeMeetingSubMenu } from "src/helpers/subMenuHelper";
import RouterHoc, { IRouterActions, IRouterProps } from "src/hoc/RouterHoc";
import * as CommitteeMeetingActions from "../../../actions/committeeMeeting";
import * as CommitteeActions from "../../../actions/committees";
import * as NavigationActions from "../../../actions/navigation";
import { NotificationAlert } from "../../../components/common/index";
import {
    DatePickerFormInputFabric,
    TextAreaFormInput,
} from "../../../components/form";
import { SelectFormInput, TextFormInput } from "../../../components/form/index";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import {
    renderRegistrationFormSaveBlock,
    renderRegistrationFormSaveSuccess,
    renderRegistrationFormSaveWarning,
} from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import {
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import {
    findLookup,
    generateOptionsFromLookup,
} from "../../../helpers/lookupHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import {
    ICommitteeMeetingReduxFormState,
    initialCommitteeMeetingState,
} from "../../../reducers/reactReduxForms/committeeMeeting";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";

import "./CommitteeMeetingPage.scss";

interface ICommitteeMeetingPageParams {
    committeeId: number;
    committeeMeetingId: number;
}

interface ICommitteeMeetingPageProps
    extends IRouterProps<ICommitteeMeetingPageParams> {
    form: Dtos.CommitteeMeeting & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ICommitteeMeetingReduxFormState;

    committeeId: number;
    committeeMeetingId: number;

    // From state
    committeeMeeting: Dtos.CommitteeMeeting;
    committee: Dtos.Committee | undefined;
    lookups: Dtos.Lookup[];

    loadingCommittee: boolean;
    loadCommitteeSuccess: boolean;
    loadCommitteeFailure: boolean;
    loadCommitteeErrorCode: string;

    loadingCommitteeMeeting: boolean;
    loadCommitteeMeetingSuccess: boolean;
    loadCommitteeMeetingFailure: boolean;
    loadCommitteeMeetingErrorCode: string;

    savingCommitteeMeeting: boolean;
    saveCommitteeMeetingSuccess: boolean;
    saveCommitteeMeetingFailure: boolean;

    creatingCommitteeMeeting: boolean;
    createCommitteeMeetingSuccess: boolean;
    createCommitteeMeetingFailure: boolean;

    validatingCommitteeMeeting: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface ICommitteeMeetingPageActions extends IRouterActions {
    clearCommitteeMeeting: CommitteeMeetingActions.ICommitteeMeetingClearActionCreator;
    loadCommitteeMeeting: CommitteeMeetingActions.ICommitteeMeetingLoadByIdActionCreator;
    saveCommitteeMeeting: CommitteeMeetingActions.ICommitteeMeetingSaveActionCreator;
    createCommitteeMeeting: CommitteeMeetingActions.ICommitteeMeetingCreateActionCreator;
    validateCommitteeMeeting: CommitteeMeetingActions.ICommitteeMeetingValidateActionCreator;

    clearCommittee: CommitteeActions.ICommitteeClearActionCreator;
    loadCommittee: CommitteeActions.ICommitteeLoadByIdActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

}

type CommitteeMeetingPageProps = ICommitteeMeetingPageProps &
    ICommitteeMeetingPageActions;

const reduxFormName: string = "reduxForms.committeeMeeting";

class CommitteeMeetingPage extends React.PureComponent<
    CommitteeMeetingPageProps,
    any
> {
    hasBeenSubmitted: boolean;

    constructor(props: CommitteeMeetingPageProps) {
        super(props);

        this.state = {
            hasBeenSubmitted: false,
        };

        this.clearCommitteeMeeting = this.clearCommitteeMeeting.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
        this.debounceValidate = this.debounceValidate.bind(this);
    }

    componentDidMount() {
        const {
            loadCommitteeMeeting,
            committeeMeetingId,
            committeeId,
            loadCommittee,
            createCommitteeMeeting,
            setBreadcrumbs,
            setDrawerItems
        } = this.props;
        

        if (committeeMeetingId) {
            // load
            setBreadcrumbs(
                CommitteeMeetingDetailsBreadcrumbs(
                    committeeId,
                    committeeMeetingId
                )
            );
            loadCommitteeMeeting(committeeMeetingId);
        } else {
            // create
            setDrawerItems([]);
            setBreadcrumbs(
                CommitteeMeetingCreateBreadcrumbs(
                    committeeId,
                    committeeMeetingId
                )
            );
            createCommitteeMeeting(committeeId);
        }

        if (committeeId) {
            loadCommittee(committeeId);
        }
    }

    componentDidUpdate(prevProps: CommitteeMeetingPageProps, _prevState) {
        const {
            form,
            committeeId,
            committeeMeetingId,
            committeeMeeting,
            loadCommittee,
            loadCommitteeMeeting,
            loadingCommitteeMeeting,
            loadCommitteeMeetingSuccess,
            savingCommitteeMeeting,
            saveCommitteeMeetingSuccess,
            validationFailures,
            navigate,
            createCommitteeMeeting,
            creatingCommitteeMeeting,
            createCommitteeMeetingSuccess,
            setDrawerItems,
            setBreadcrumbs,
            permissions,
            committee,
            loadCommitteeMeetingFailure,
            loadCommitteeFailure,
            loadCommitteeMeetingErrorCode,
            loadCommitteeErrorCode,
        } = this.props;

        if (loadCommitteeFailure) {
            navigate(`/error/${loadCommitteeErrorCode}`);
        }
        if (loadCommitteeMeetingFailure) {
            navigate(`/error/${loadCommitteeMeetingErrorCode}`);
        }

        if (committee && committeeMeeting && committeeMeetingId) {
            setDrawerItems(
                CommitteeMeetingSubMenu(committeeMeeting, permissions)
            );
            setBreadcrumbs(
                CommitteeMeetingDetailsBreadcrumbs(
                    committeeId,
                    committeeMeetingId,
                    committee.name,
                    this.getCommitteeMeetingName(committeeMeeting)
                )
            );
        } else {
            setBreadcrumbs(
                CommitteeMeetingCreateBreadcrumbs(
                    committeeId,
                    committeeMeetingId,
                    committee?.name
                )
            );
        }

        if (committeeId && prevProps.committeeId != committeeId) {
            loadCommittee(committeeId);
        }

        if (
            committeeMeetingId &&
            prevProps.committeeMeetingId != committeeMeetingId
        ) {
            loadCommitteeMeeting(committeeMeetingId);
        } else if (!committeeMeetingId && prevProps.committeeMeetingId) {
            createCommitteeMeeting(committeeId);
        }

        if (!loadingCommitteeMeeting && prevProps.loadingCommitteeMeeting) {
            if (loadCommitteeMeetingSuccess) {
                this.loadForm();
            }
        }

        if (form != prevProps.form) {
            this.debounceValidate();
        }

        if (!savingCommitteeMeeting && prevProps.savingCommitteeMeeting) {
            if (saveCommitteeMeetingSuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveWarning(
                                validationFailures
                            )}
                            icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                        />
                    );
                } else {
                    Alert.success(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveSuccess()}
                            icon={FontAwesomeIcons.Solid.CHECK}
                        />
                    );
                }
                if (form.saveAndReturn) {
                    navigate("/committees/" + committeeId + "/meetings");
                } else if (
                    !form.saveAndReturn &&
                    committeeMeetingId &&
                    committeeMeetingId > 0
                ) {
                    this.loadForm();
                } else if (
                    !form.saveAndReturn &&
                    !committeeMeetingId &&
                    committeeMeeting &&
                    committeeMeeting.id > 0
                ) {
                    navigate(
                        "/committees/" +
                            committeeId +
                            "/meetings/" +
                            committeeMeeting.id +
                            "/details"
                    );
                }
            } else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }

        if (!creatingCommitteeMeeting && prevProps.creatingCommitteeMeeting) {
            if (createCommitteeMeetingSuccess) {
                this.loadForm();
            }
        }
    }

    componentWillUnmount() {
        const { resetForm, loadForm } = this.props;

        this.clearCommitteeMeeting();
        loadForm(reduxFormName, initialCommitteeMeetingState);
        resetForm(reduxFormName);
    }

    clearCommitteeMeeting() {
        this.props.clearCommitteeMeeting();
        this.props.clearCommittee();
    }

    showCommitteeMeeting(): boolean {
        const { loadingCommitteeMeeting, loadCommitteeMeetingSuccess } =
            this.props;

        if (!loadingCommitteeMeeting && loadCommitteeMeetingSuccess) {
            return true;
        }

        return false;
    }

    debounceValidate = debounce(async () => {
        const hasBeenSubmitted = this.state?.hasBeenSubmitted;
        const { form, validatingCommitteeMeeting, validateCommitteeMeeting } =
            this.props;

        let changes: Dtos.CommitteeMeeting = {} as Dtos.CommitteeMeeting;

        if (form && hasBeenSubmitted && !validatingCommitteeMeeting) {
            await validateCommitteeMeeting(Object.assign({ ...form }, changes));
        }
    }, 250);

    getCommitteeMeetingName(committeeMeeting: Dtos.CommitteeMeeting): string {
        let result = "";

        if (committeeMeeting.meetingDate) {
            result += moment(
                committeeMeeting.meetingDate,
                "YYYY-MM-DD HH:mm:ss.SSSSSSS Z"
            ).format("DD/MM/YYYY");
        }

        if (committeeMeeting.location) {
            result +=
                result !== ""
                    ? ` - ${committeeMeeting.location}`
                    : committeeMeeting.location;
        }

        if (committeeMeeting.room) {
            result +=
                result !== ""
                    ? ` - ${committeeMeeting.room}`
                    : committeeMeeting.room;
        }

        if (committeeMeeting.time) {
            result +=
                result !== ""
                    ? ` - ${committeeMeeting.time}`
                    : committeeMeeting.time;
        }

        return result;
    }

    render() {
        const { loadingCommitteeMeeting, creatingCommitteeMeeting } =
            this.props;

        return (
            <RestrictedLayout
                loading={loadingCommitteeMeeting || creatingCommitteeMeeting}
                permission={Dtos.Permission.CommitteeMeetingView}
            >
                {this.renderContent()}
            </RestrictedLayout>
        );
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            permissions,
            savingCommitteeMeeting,
        } = this.props;

        const hasPermission: boolean = AuthenticationHelper.hasPermission(
            permissions,
            Dtos.Permission.CommitteeMeetingUpdate
        );
        const formDisabled: boolean =
            !hasPermission ||
            savingCommitteeMeeting ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            detailsGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <h1>Details</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "committeeMeeting",
                                        {
                                            committeeMeetingTypeId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "committeeMeeting",
                                                                "committeeMeetingTypeId",
                                                                lookups
                                                            ),
                                                            form.committeeMeetingTypeId
                                                        ),
                                                },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-2",
                                                fieldClassName:
                                                    "col-sm-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "committeeMeeting",
                                        {
                                            meetingDate: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType:
                                                    DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-4",
                                                fieldClassName:
                                                    "col-sm-7 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "committeeMeeting",
                                        {
                                            time: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-4",
                                                fieldClassName:
                                                    "col-sm-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-md-4">
                                    {renderFormControls(
                                        form,
                                        "committeeMeeting",
                                        {
                                            room: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-6",
                                                fieldClassName:
                                                    "col-sm-6 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-4">
                                    {renderFormControls(
                                        form,
                                        "committeeMeeting",
                                        {
                                            location: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-6 pl-4",
                                                fieldClassName:
                                                    "col-sm-6 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-4">
                                    {renderFormControls(
                                        form,
                                        "committeeMeeting",
                                        {
                                            city: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-6 pl-4",
                                                fieldClassName:
                                                    "col-sm-6 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "committeeMeeting",
                                        {
                                            website: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-2",
                                                fieldClassName:
                                                    "col-sm-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            commentGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Comments</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-3 pb-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "committeeMeeting",
                                        {
                                            comments: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextAreaFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-sm-0",
                                                fieldClassName:
                                                    "col-sm-12 generic-form-field",
                                                inputLabel: " ",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <Form
                model={reduxFormName}
                onSubmit={(val, _event) => this.handleOnSubmit(val)}
                onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
            >
                {renderFormControls(
                    form,
                    "committeeMeeting",
                    formComponents,
                    lookups,
                    validationFailures,
                    formProperties,
                    changeForm
                )}
                <div className="mt-4 mb-4 text-right">
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(
                                reduxFormName + ".saveAndReturn",
                                false
                            );
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(
                                reduxFormName + ".saveAndReturn",
                                true
                            );
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button
                        onClick={this.onCancel}
                        className="btn btn-primary mr-2"
                    >
                        {" "}
                        Cancel{" "}
                    </button>
                </div>
            </Form>
        );
    }

    renderErrorAlert(): any {
        return (
            <div>
                The form was <strong> not </strong> saved.
            </div>
        );
    }

    renderWarningAlert(): any {
        const { validationFailures } = this.props;

        return (
            <div>
                The form was saved but was invalid with{" "}
                {validationFailures.length} errors.
            </div>
        );
    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>;
    }

    handleOnSubmit(data: Dtos.CommitteeMeeting) {
        const { hasBeenSubmitted } = this.state;
        const { saveCommitteeMeeting } = this.props;

        if (!hasBeenSubmitted) {
            this.setState({ hasBeenSubmitted: true });
        }

        if (data) {
            let changes: Dtos.CommitteeMeeting = {} as Dtos.CommitteeMeeting;
            saveCommitteeMeeting(Object.assign({ ...data }, changes));
        }
    }

    handleOnSubmitFailed(_data: Dtos.CommitteeMeeting) {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    }

    onCancel() {
        const { navigate, committeeId } = this.props;

        navigate("/committees/" + committeeId + "/meetings");
    }

    loadForm() {
        const { loadForm, committeeMeeting } = this.props;

        let extraData: Dtos.CommitteeMeeting = {} as Dtos.CommitteeMeeting;

        loadForm(
            reduxFormName,
            Object.assign({ ...committeeMeeting }, extraData)
        );
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: CommitteeMeetingPageProps
): ICommitteeMeetingPageProps => {
    let committeeMeeting: Dtos.CommitteeMeeting | undefined = !(
        state.committeeMeeting.formData instanceof Array
    )
        ? state.committeeMeeting.formData
        : undefined;
    let committee: Dtos.Committee | undefined = !(
        state.committees.formData instanceof Array
    )
        ? state.committees.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        match: ownProps.match,
        committeeId: ownProps.match
            ? ownProps.match.params.committeeId
            : undefined!,
        committeeMeetingId:
            ownProps.match &&
            ownProps.match.params.committeeMeetingId?.toString() != "create"
                ? ownProps.match.params.committeeMeetingId
                : undefined!,

        history: ownProps.history,
        location: ownProps.location,

        committeeMeeting: committeeMeeting!,
        committee: committee!,

        loadingCommitteeMeeting:
            state.committeeMeeting.loadState &&
            state.committeeMeeting.loadState.status == RequestState.Pending,
        loadCommitteeMeetingSuccess:
            state.committeeMeeting.loadState &&
            state.committeeMeeting.loadState.status == RequestState.Success,
        loadCommitteeMeetingFailure:
            state.committeeMeeting.loadState &&
            state.committeeMeeting.loadState.status == RequestState.Failure,
        loadCommitteeMeetingErrorCode:
            state.committeeMeeting.loadState.errorCode,

        loadingCommittee:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Pending,
        loadCommitteeSuccess:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Success,
        loadCommitteeFailure:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Failure,
        loadCommitteeErrorCode: state.committees.loadState.errorCode,

        savingCommitteeMeeting:
            state.committeeMeeting.saveState &&
            state.committeeMeeting.saveState.status == RequestState.Pending,
        saveCommitteeMeetingSuccess:
            state.committeeMeeting.saveState &&
            state.committeeMeeting.saveState.status == RequestState.Success,
        saveCommitteeMeetingFailure:
            state.committeeMeeting.saveState &&
            state.committeeMeeting.saveState.status == RequestState.Failure,

        creatingCommitteeMeeting:
            state.committeeMeeting.createState &&
            state.committeeMeeting.createState.status == RequestState.Pending,
        createCommitteeMeetingSuccess:
            state.committeeMeeting.createState &&
            state.committeeMeeting.createState.status == RequestState.Success,
        createCommitteeMeetingFailure:
            state.committeeMeeting.createState &&
            state.committeeMeeting.createState.status == RequestState.Failure,

        validatingCommitteeMeeting:
            state.committeeMeeting.validateState &&
            state.committeeMeeting.validateState.status == RequestState.Pending,

        user: state.user.data,
        permissions: permissions,
        lookups: state.committeeMeeting.lookups,

        form: state.reduxForms.committeeMeeting,
        formState: state.committeeMeeting.formState,
        formProperties: state.committeeMeeting.formProperties,

        reduxFormState: state.reduxForms.formState.committeeMeeting,
        validationFailures: committeeMeeting
            ? state.committeeMeeting.validationFailures
            : undefined,
    };
};

const mapDispatchToProps = (
    dispatch,
    ownProps: CommitteeMeetingPageProps
): ICommitteeMeetingPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadCommitteeMeeting: bindActionCreators(
            CommitteeMeetingActions.LoadCommitteeMeetingById,
            dispatch
        ),
        clearCommitteeMeeting: bindActionCreators(
            CommitteeMeetingActions.Clear,
            dispatch
        ),

        loadCommittee: bindActionCreators(
            CommitteeActions.LoadCommitteeById,
            dispatch
        ),
        clearCommittee: bindActionCreators(CommitteeActions.Clear, dispatch),

        saveCommitteeMeeting: bindActionCreators(
            CommitteeMeetingActions.SaveCommitteeMeeting,
            dispatch
        ),
        createCommitteeMeeting: bindActionCreators(
            CommitteeMeetingActions.CreateCommitteeMeeting,
            dispatch
        ),

        validateCommitteeMeeting: bindActionCreators(
            CommitteeMeetingActions.ValidateCommitteeMeeting,
            dispatch
        ),

        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        )
    };
};

export default RouterHoc<
    ICommitteeMeetingPageParams,
    CommitteeMeetingPageProps
>(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(
        CommitteeMeetingPage
    ) as unknown as ComponentType<CommitteeMeetingPageProps>
) as ComponentType<any>;
